export default __webpack_public_path__ + "static/media/baby27.bb864ec4.gif";